"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ThreadPriority;
(function (ThreadPriority) {
    ThreadPriority[ThreadPriority["LOW"] = 10] = "LOW";
    ThreadPriority[ThreadPriority["HIGH"] = 90] = "HIGH";
})(ThreadPriority = exports.ThreadPriority || (exports.ThreadPriority = {}));
exports.THREAD_PRIORITIES = [
    ThreadPriority.LOW,
    ThreadPriority.HIGH,
];
//# sourceMappingURL=thread-priority.js.map